import {JsonObject, JsonProperty} from "typescript-json-serializer";

@JsonObject()
export class DataPortalConfiguration {

    /**
     * URL data portal Home
     */
    @JsonProperty()
    declare homeUrl: string;

    constructor() {}

}
